import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import Landing from "./Landing";
import "../app/globals.css";

const Workbench = lazy(() => import("./analysis/Workbench"));

const isApplicationRoute =
  window.location.pathname === "/app" ||
  window.location.pathname.startsWith("/app/");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense fallback={<main aria-live="polite">正在打开工作台…</main>}>
      {isApplicationRoute ? <Workbench /> : <Landing />}
    </Suspense>
  </StrictMode>,
);
